/**
 * Findstr Accessibility Enhancement Script for Programs Listing
 *
 * This script improves the accessibility of Tom Select dropdown filters (campus) in findstr components.
 * It focuses on making the multi-select checkboxes properly announced by screen readers.
 *
 * Functionality:
 * - Waits for the findstr component to fully load via the 'findstrLoaded' event
 * - Sets appropriate ARIA role ("search") on filter containers
 * - Uses MutationObserver to detect when dropdowns are added to the DOM
 * - Watches for dropdown activation (when the dropdown menu opens)
 * - Transforms standard options into proper checkbox controls for better screen reader support:
 *   - Changes role="option" to role="checkbox" on selectable items
 *   - Sets aria-checked state based on selection status
 *   - Removes duplicate ARIA roles from nested input elements
 *
 */

document.addEventListener('findstrLoaded', function () {
  const programFilters = document.querySelector('.program-filters');

  if (!programFilters) {
    console.info('Program filters container not found');
    return;
  }

  programFilters.setAttribute('role', 'search');

  fixToggleInput();

  // Watch for DOM changes to detect when dropdown is added
  const domObserver = new MutationObserver(() => {
    const dropdownContainer = programFilters.querySelector(
      '.findstr-field-dropdown'
    );

    if (dropdownContainer) {
      const dropdown = dropdownContainer.querySelector(
        '.findstrFieldContainer > .ts-wrapper'
      );

      if (dropdown) {
        // Stop watching for DOM changes once we found the element
        domObserver.disconnect();

        // Observe the dropdown for class changes
        const classObserver = new MutationObserver((mutations) => {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
              if (dropdown.classList.contains('dropdown-active')) {
                const dropdownContent = dropdown.querySelector(
                  '.ts-dropdown-content'
                );
                if (dropdownContent) {
                  const options =
                    dropdownContent.querySelectorAll('[data-selectable]');
                  console.log('Options:', options);

                  // Add accessibility attributes to the div elements instead of the inputs
                  options.forEach((option) => {
                    // Remove the default role="option"
                    option.removeAttribute('role');
                    // Add checkbox role to the div
                    option.setAttribute('role', 'checkbox');
                    const isSelected = option.classList.contains('selected');
                    option.setAttribute(
                      'aria-checked',
                      isSelected ? 'true' : 'false'
                    );

                    // Remove role from the checkbox input to avoid duplicate roles
                    const checkbox = option.querySelector(
                      '.tomselect-checkbox'
                    );
                    if (checkbox) {
                      checkbox.removeAttribute('role');
                    }
                  });
                }
              }
            }
          });
        });

        classObserver.observe(dropdown, {
          attributes: true,
        });
      }
    }
  });

  // Start observing the program filters container
  domObserver.observe(programFilters, {
    childList: true,
    subtree: true,
  });

  // Also try immediately in case the dropdown is already there
  const dropdownContainer = programFilters.querySelector(
    '.findstr-field-dropdown'
  );
  if (dropdownContainer) {
    const dropdown = dropdownContainer.querySelector(
      '.findstrFieldContainer > .ts-wrapper'
    );
    if (dropdown) {
      const classObserver = new MutationObserver((mutations) => {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            if (dropdown.classList.contains('dropdown-active')) {
              const dropdownContent = dropdown.querySelector(
                '.ts-dropdown-content'
              );
              if (dropdownContent) {
                const options =
                  dropdownContent.querySelectorAll('[data-selectable]');
                options.forEach((option) => {
                  option.removeAttribute('role');
                  option.setAttribute('role', 'checkbox');
                  const isSelected = option.classList.contains('selected');
                  option.setAttribute(
                    'aria-checked',
                    isSelected ? 'true' : 'false'
                  );

                  const checkbox = option.querySelector('.tomselect-checkbox');
                  if (checkbox) {
                    checkbox.removeAttribute('role');
                  }
                });
              }
            }
          }
        });
      });

      classObserver.observe(dropdown, {
        attributes: true,
      });
    }
  }

  function fixToggleInput() {
    const toggleField = programFilters.querySelector('.findstr-field-toggle');

    const toggleInput = toggleField.querySelector('input[type="checkbox"]');
    const toggleLabel = toggleField.querySelector('.toggle-label');

    if (toggleInput && toggleLabel) {
      // Get the actual label text
      const labelText = toggleLabel.textContent.trim();

      // Fix the aria-label if it's "null"
      if (
        toggleInput.getAttribute('aria-label') === 'null' ||
        !toggleInput.getAttribute('aria-label')
      ) {
        toggleInput.setAttribute('aria-label', labelText);
      }

      // Add proper accessibility attributes
      toggleInput.setAttribute('role', 'switch');
      toggleInput.setAttribute(
        'aria-checked',
        toggleInput.checked ? 'true' : 'false'
      );

      // Update aria-checked when the toggle changes
      toggleInput.addEventListener('change', function () {
        this.setAttribute('aria-checked', this.checked ? 'true' : 'false');
      });
    }
  }

  // Use MutationObserver to fix toggle input that might be added dynamically
  const toggleObserver = new MutationObserver(() => {
    fixToggleInput();
  });

  toggleObserver.observe(programFilters, {
    childList: true,
    subtree: true,
  });
});
